import styled from 'styled-components'

export const RootS = styled.div`
  padding: ${({ theme }) => theme.metrics.space5};
`

export const ListS = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`

export const AppS = styled.li`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.metrics.space3};

  padding: ${({ theme }) => theme.metrics.space5};

  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.gray40};
  border-radius: ${({ theme }) => theme.metrics.radius};

  & + & {
    margin-top: ${({ theme }) => theme.metrics.space3};
  }
`

export const EmptyS = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;

  padding: ${({ theme }) => theme.metrics.space6};
  text-align: center;
`
